import { render } from "./PriceTemplateCreatePage.vue?vue&type=template&id=0895fdc7"
import script from "./PriceTemplateCreatePage.vue?vue&type=script&lang=js"
export * from "./PriceTemplateCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__